<template>
  <div class="resume">
    <div v-if="addonProcess !== 'resume-addon-mars'" class="row-block">
      <div>{{ $tr('responses.resume.name') }}</div>
      <div>{{ candidate.name }}</div>
    </div>

    <div v-if="addonProcess !== 'resume-addon-mars'" class="row-block">
      <div>{{ $tr('responses.resume.surname') }}</div>
      <div>{{ candidate.surname }}</div>
    </div>

    <div class="row-block">
      <div>{{ $tr('responses.resume.email') }}</div>
      <div>
        <a :href="`mailto:${candidate.email}`">{{ candidate.email }}</a>
      </div>
    </div>

    <div class="row-block">
      <div>{{ $tr('responses.resume.phone') }}</div>
      <div>{{ candidate.phone }}</div>
    </div>

    <div v-for="(prop, index) in response.properties" :key="index" class="row-block">
      <div>{{ prop.title }}</div>

      <div :class="prop.highlight">
        <router-link
          v-if="getProcessName === 'x5'"
          :to="{ path: '/interview-video-result/', query: { source: prop.value } }"
          tag="a"
          target="_blank"
          rel="noopener"
        >
          {{ $tr('onlineInterview.room.goto') }}
        </router-link>

        <div v-else>
          <a v-if="prop.type === 'link'" :href="prop.value" target="_blank" rel="noopener">
            {{ $tr('onlineInterview.room.goto') }}
          </a>
          <span v-else>{{ prop.value }}</span>
        </div>
      </div>
    </div>

    <div v-if="response.resume_url !== null" class="row-block">
      <div>{{ $tr('responses.resume.cvLink') }}</div>
      <div>
        <c-v-link :link="response.resume_url" />
      </div>
    </div>

    <div v-if="addonProcess" class="row-block">
      <div>TalentQ</div>
      <div>
        <component :is="addonProcess" class="resume__addon" :response-id="response.id" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CVLink from '@/components/shared/CVLink.vue';
const ResumeAddonMars = () => import('@/process/mars/components/response/tabs/ResumeAddon');
import PROCESS_NAMES from '@/process/names';

export default {
  name: 'TabResumeDefault',

  components: {
    CVLink,
    ResumeAddonMars
  },

  props: {
    response: Object
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    addonProcess() {
      if (this.getProcessName !== undefined) {
        if (
          this.getProcessName === PROCESS_NAMES.MARS ||
          this.getProcessName === PROCESS_NAMES.MARS_MIEP ||
          this.getProcessName === PROCESS_NAMES.MARS_MLEP
        ) {
          return 'resume-addon-mars';
        }
      }

      return false;
    },

    candidate() {
      return this.response.candidate;
    }
  }
};
</script>

<style lang="scss" scoped>
.resume {
  padding: 15px 0;

  &__addon {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .row-block {
    margin: 20px 0;
    display: flex;

    .red {
      color: $red !important;
      background-color: transparent !important;
      border-color: transparent !important;
    }

    & > div {
      width: calc(50% - 20px);
      padding-right: 20px;
    }

    & > div:first-child {
      font-weight: bold;
    }
  }
}
</style>
